// extracted by mini-css-extract-plugin
export var BtnMenu = "t_G";
export var aniSpin = "t_d";
export var line = "t_J";
export var menu = "t_H";